module.exports = new __parcel__URL__("Marketing Campaign Hover.5c2b5955.svg").toString();